import { useEffect, useState } from 'react';

import { Storage } from '@/utils/Storage';
import { questionTypeMap, feedBackTypeMap } from '@/utils/contants/caseSimulation';
import { handleSubmitAnswerSheet } from '@/api/grt/simulation';
import { getSearchStr } from '@/utils/Page';
const searchStr = getSearchStr();
const useEvent = (props) => {
    const { side = 'web' } = props;
    const [isFirst, setIsFirst] = useState(true);
    const [errorMsg, setErrorMsg] = useState('');
    let { navigate, params } = props;
    let { agentId, caseId, sceneId } = params;
    const [resultModal, setResultModal] = useState(false);
    const [resultData, setResultData] = useState({});
    const {
        store: { simulation }
    } = props;
    const [eventStatus, setEventStatus] = useState(1); //1:事件描述 2:答题区域
    const {
        curEventIndex,
        events,

        curEventData,
        setHeaderIcon,
        curQuestionIndex,
        curQuestion,
        curUserAnswer,
        resetCurUserAnswer,
        changeCurEventIndex,
        changeCurQuestionIndex,

        setLoading,
        verifyLogin
    } = simulation;

    useEffect(() => {
        simulation.updatePageShowEvent();
    }, [curEventIndex, events]);
    const onClickArrow = () => {
        setEventStatus(2);
    };
    const goEventResult = async () => {
        let res = await verifyLogin();
        if (!res) {
            return;
        }
        navigate(`/${side}/o/${agentId}/simulation/${caseId}/${sceneId}/event-result${searchStr}`, { replace: true });
    };
    const onNext = () => {
        if (curEventData.questions.length === curQuestionIndex + 1) {
            if (curEventIndex === events.length - 1) {
                goEventResult();
                return;
            } else {
                //下一个事件
                setEventStatus(1);
                changeCurEventIndex(curEventIndex + 1);
            }
        } else {
            //下一个问题

            changeCurQuestionIndex(curQuestionIndex + 1);
            setEventStatus(2);
        }

        setResultModal(false);
    };
    //重新选择
    const onReChose = () => {
        resetCurUserAnswer();
        setResultModal(false);
    };
    const getCustomId = (options) => {
        let obj = options.find((item) => item.customer_input);
        return obj;
    };
    const isCanSubmit = () => {
        let canSubmit = true;
        let submitData = {
            ...curUserAnswer
        };

        if (curQuestion.question_type === questionTypeMap.short_answer) {
            if (!curUserAnswer.custom_value || curUserAnswer.custom_value.trim() === '') {
                canSubmit = false;
            }
        }
        if (curQuestion.question_type !== questionTypeMap.short_answer) {
            if (curUserAnswer?.user_answer.length === 0) {
                canSubmit = false;
            }
            let customItem = getCustomId(curQuestion.options);
            //如果有自定义选项，且用户选择自定义选项，未输入自定义值，则不能提交
            if (customItem) {
                submitData.user_answer = submitData.user_answer.filter((item) => item !== customItem.id);
                if (curUserAnswer.user_answer.includes(customItem.id) && (!curUserAnswer.custom_value || curUserAnswer.custom_value.trim() === '')) {
                    canSubmit = false;
                }
            } else {
                curUserAnswer.custom_value = '';
            }
        }
        return { canSubmit, submitData };
    };
    //答题
    const onSubmit = async () => {
        let isLogin = await verifyLogin();
        if (!isLogin) {
            return;
        }
        let { canSubmit, submitData } = isCanSubmit();
        if (!canSubmit) {
            return;
        }
        setErrorMsg('');
        setLoading(true);
        let res = await handleSubmitAnswerSheet({
            runtime_session_id: caseId,
            question_id: curQuestion.question_id,
            ...submitData
        });
        if (res && res.success) {
            console.log(res, '提交答案');
            setResultData(res?.data);
            if (res?.data?.feedback_mode === feedBackTypeMap.notBack) {
                //不需要反馈直接进入下一个
                onNext();
            } else {
                //需要反馈
                setResultModal(true);
            }

            setLoading(false);
        } else {
            setErrorMsg(res?.msg || '提交失败');
            setLoading(false);
        }

        // setResultModal(true);
    };
    useEffect(() => {
        setHeaderIcon({
            role: true,
            back: true,
            reStart: true
        });
        let roleGuide = Storage.get(simulation.roleStorageName);
        if (!roleGuide) {
            setTimeout(() => {
                simulation.setGuideModal('role');
            }, 2000);
        }
    }, []);

    useEffect(() => {
        setIsFirst(true);
        setTimeout(() => {
            setIsFirst(false);
        }, 300);
    }, [curEventIndex]);

    return {
        eventStatus,
        isFirst,
        errorMsg,
        resultModal,
        setResultModal,
        resultData,
        setResultData,
        onSubmit,
        onNext,
        isCanSubmit,
        onReChose,
        onClickArrow
    };
};
export default useEvent;
